import { render } from "./DesignLibrary.vue?vue&type=template&id=04b74af0&scoped=true"
import script from "./DesignLibrary.vue?vue&type=script&lang=js"
export * from "./DesignLibrary.vue?vue&type=script&lang=js"

import "./DesignLibrary.vue?vue&type=style&index=0&id=04b74af0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04b74af0"]])

export default __exports__